import Vue from "vue";
import Router from "vue-router";
import { applySeo, DEFAULT_SEO, DEFAULT_ROBOTS, ALLOWED_ROBOTS } from "@/utils/seo";

Vue.use(Router);

// 懒加载：各页面按需分包，不增加首屏体积
const Home = () => import("@/views/Home.vue");
const Solutions = () => import("@/views/Solutions.vue");
const Pricing = () => import("@/views/Pricing.vue");
const Download = () => import("@/views/Download.vue");

// 固定页头高度（与 SiteHeader 的 .site-header__inner 保持一致）
const HEADER_OFFSET = 64;

const router = new Router({
  /*
   * 使用 history 模式
   * 说明：原先未配置 mode，走 hash（/#/solutions）。hash 模式下
   * 「跨页锚点」（例如在 /solutions 点击「开启合作」要回到首页并定位到联系区）
   * 会拼成 #/solutions#contact 这类无法解析的地址，因此改为 history。
   * 开发环境 webpack-dev-server 已配置 historyApiFallback（webpack.dev.conf.js:26），
   * 生产环境需由服务器把未知路径回退到 index.html。
   */
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        title: "氦闪云 - 数字基础设施与企业级技术服务",
        description:
          "合肥氦闪科技有限公司以软件工程能力，构建可演进、可连接、可持续的企业级数字服务，涵盖氦闪云开放 API 中台、IoT 物联网平台、硬件支持平台与私有化定制开发。",
        keywords:
          "氦闪科技,氦闪云,hiasoon,数字基础设施,企业级技术服务,氦闪中台,开放API平台,私有化定制开发",
        robots: ALLOWED_ROBOTS
      }
    },
    {
      path: "/solutions",
      name: "Solutions",
      component: Solutions,
      meta: {
        title: "解决方案 - 应用场景、交付能力与技术底座 | 氦闪科技",
        description:
          "氦闪科技按「问题 → 能力 → 技术底座」组织工程能力：从具体应用场景出发，说明可交付的解决方案能力、技术架构与技术栈选型，让能力落到可用的方案。",
        keywords:
          "解决方案,企业数字化,API集成方案,技术架构,物联网方案,私有化定制开发,氦闪科技",
        robots: ALLOWED_ROBOTS
      }
    },
    {
      path: "/pricing",
      name: "Pricing",
      component: Pricing,
      meta: {
        title: "定价 - 合作方式与方案 | 氦闪科技",
        description:
          "氦闪科技按业务集成深度与交付节奏提供多种合作方式，覆盖标准化 API 接入、平台共建与私有化定制开发。具体方案与报价请联系我们沟通。",
        keywords: "定价,合作方式,API接入,私有化定制开发,项目合作,氦闪科技",
        // 暂不收录：页面当前为结构占位（价格与权益待补充），
        // 待真实定价上线后改为 ALLOWED_ROBOTS，并同步在 static/sitemap.xml 中恢复条目。
        robots: DEFAULT_ROBOTS
      }
    },
    {
      path: "/download",
      name: "Download",
      component: Download,
      meta: {
        title: "下载中心 - SDK、开发工具与配套资源 | 氦闪科技",
        description:
          "获取氦闪云产品的 SDK、开发工具与配套资源，支持按分类筛选、版本查看与整包下载，部分资源需登录开发者平台后获取。",
        keywords: "下载中心,SDK下载,开发工具,氦闪云资源,API SDK,固件工具",
        robots: ALLOWED_ROBOTS
      }
    },
    {
      path: "*",
      redirect: "/"
    }
  ],

  /*
   * 滚动行为
   * - 带 hash：滚动到对应锚点，并预留固定页头高度，避免标题被遮住
   * - 浏览器前进/后退：恢复原位置
   * - 普通切换页面：回到顶部
   */
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) {
      return { el: to.hash, top: HEADER_OFFSET, behavior: "smooth" };
    }
    return { x: 0, y: 0 };
  }
});

// 路由切换后同步 title / description / keywords / robots / canonical / OG
// 最小抓取原则：未显式声明 robots 的路由兜底为 noindex,nofollow
router.afterEach(to => {
  applySeo({
    title: to.meta.title || DEFAULT_SEO.title,
    description: to.meta.description || DEFAULT_SEO.description,
    keywords: to.meta.keywords || DEFAULT_SEO.keywords,
    robots: to.meta.robots || DEFAULT_ROBOTS,
    path: to.fullPath
  });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js